import { env } from "@/config/env";
import { useAuthStore } from "@/store/auth";
import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import axios from "axios";

export const api = axios.create({
    baseURL: env.apiBaseUrl,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
    paramsSerializer: {
        indexes: null
    }
})

// Request interceptor per aggiungere il token
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const auth = useAuthStore()

        // Aggiungi il token se presente e valido
        if (auth.accessToken && auth.isAuthenticated) {
            config.headers.Authorization = `Bearer ${auth.accessToken}`
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor per gestire errori di autenticazione
api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        const auth = useAuthStore()

        // Gestisci errori 401 (non autorizzato)
        if (error.response?.status === 401) {
            console.warn("Token non valido o scaduto, redirect al login")

            // Pulisci la sessione e reindirizza
            auth.clearSession()
            auth.loginRedirect()
        }

        return Promise.reject(error)
    }
)
// Request interceptor
api.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        console.error('❌ Request Error:', error)
        return Promise.reject(error)
    }
)

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.group('❌ API Error')
        console.error('URL:', error.config?.url)
        console.error('Method:', error.config?.method)
        console.error('Status:', error.response?.status)
        console.error('Status Text:', error.response?.statusText)

        if (error.response?.data) {
            console.error('Response Data:', error.response.data)
        } else if (error.response?.status >= 400) {
            console.error('Response Data: No data received from server. Status ' + error.response?.status)
        }

        console.groupEnd()
        return Promise.reject(error)
    }
)

export default api
